// initial state
import Router from "../../router";
import {registrationService} from "../../services";


const state = {
    confirm_all_consents: false,
    personal: {
        name: null,
        last_name: null,
        street: null,
        house_number: null,
        zip: null,
        city: null,
        gender: null,
        date_of_birth: null,
        country: null,
        phone_number: null,
        phone_number_land: null,
        education: 1,
        family_members: 0,
        status: 0,
        childs: [],
    },
    account: {
        email: null,
        password: null,
        password_again: null,
        confirm_cond: false
    },
    consent_channels: {
        email: false,
        sms: false
    },
    current_step: 1,
    registration_problem: false,
    registration_problem_msg: ''
};

// getters
const getters = {

};

// actions
const actions = {
    checkStep({dispatch, commit}, mustBe){
        if (mustBe > state.current_step){
            dispatch('goToStep', state.current_step);
        }
    },
    goToStep({dispatch, commit}, step){
        commit('setCurrentStep', step);
        Router.push('/ustvari/vclanitev/korak'+step);
    },
    addChild(context){
        context.commit('addChild')
    },
    removeChild(context, index){
        context.commit('removeChild', index);
    },
    joinClub({dispatch, commit}, {}){
        registrationService.joinClub({
            'personal': state.personal,
            'account': state.account,
            'consents': state.consents,
            'consent_channels': state.consent_channels,
        }).then(
            data => {
                // got back to start
                commit('setCurrentStep', 1);
                if (data.has_email_confirmation) {
                    dispatch('application/emailSentMessage', {
                        title: 'Le še potrditev e-naslova',
                        text: 'Za zaključek postopka prosim potrdite povezavo, ki smo jo poslali na vaš e-naslov.'
                    }, {root: true});
                } else {
                    dispatch('application/fetchInitialInfo', {}, {root: true});
                }
            },
            error => {
                commit('setRegistrationProblem', error.message)
            }
        );

    },
    updateCityFromZIP({dispatch, commit}){
        registrationService.postOffice(state.personal.zip).then(
            data => {
                if (data.name) {
                    commit('setCity', data.name);
                    commit('setCountry', 'SI');
                }
            },
            error => {

            }
        );
    },
    refreshConsent({dispatch, commit}){

    }
};

// mutations
const mutations = {
    addChild(state) {
        state.personal.childs.push({
            'date_of_birth': null,
            'gender': null
        });
    },
    removeChild(state, index) {
        state.personal.childs.splice(index, 1);
    },
    setCity(state, city){
        state.personal.city = city;
    },
    setCurrentStep(state, step){
        state.current_step = step;
    },
    setCountry(state, city){
        state.personal.country = city;
    },
    setConfirmAllConsents(state, status){
        state.confirm_all_consents = status;
    },
    confirmAllConsents(state, {p, v}){
        state.consents.adjusted_offer = v;
        state.consents.market_researches = v;
        state.consent_channels.digital = v;
        state.consent_channels.email = v;
        state.consent_channels.mail = v;
        state.consent_channels.sms = v;
        state.consent_channels.web = v;
        state.confirm_all_consents = v;
    },
    setRegistrationProblem(state, message){
        if (message != null){
            state.registration_problem = true;
        } else {
            state.registration_problem = false;
        }
        state.registration_problem_msg = message;
    },

};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}